import type { RequestConfig } from '@umijs/max';
import { message, notification } from 'antd';
import { logoutToLogin } from '@/utils/session';

enum ErrorShowType {
  SILENT = 0,
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 3,
  REDIRECT = 9,
}

interface ResponseStructure {
  success: boolean;
  data: any;
  errorCode?: number;
  errorMessage?: string;
  showType?: ErrorShowType;
}

const getHttpErrorMessage = (error: any) => {
  const status = error?.response?.status;
  const responseData = error?.response?.data;
  const backendMessage =
    responseData?.msg ||
    responseData?.message ||
    responseData?.errorMessage ||
    error?.message;

  if (backendMessage) {
    return status ? `请求失败(${status})：${backendMessage}` : backendMessage;
  }

  if (status) {
    return `请求失败(${status})，请稍后重试`;
  }

  return '请求失败，请稍后重试';
};

export const errorConfig: RequestConfig = {
  errorConfig: {
    errorThrower: (res) => {
      const { success, data, errorCode, errorMessage, showType } =
        res as unknown as ResponseStructure;
      if (typeof success === 'boolean' && !success) {
        const error: any = new Error(errorMessage);
        error.name = 'BizError';
        error.info = { errorCode, errorMessage, showType, data };
        throw error;
      }
    },
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;

      if (
        error &&
        typeof error === 'object' &&
        'code' in error &&
        !error.response &&
        !error.request
      ) {
        return;
      }

      if (error.name === 'BizError') {
        const errorInfo: ResponseStructure | undefined = error.info;
        if (errorInfo) {
          const { errorMessage, errorCode } = errorInfo;
          switch (errorInfo.showType) {
            case ErrorShowType.SILENT:
              break;
            case ErrorShowType.WARN_MESSAGE:
              message.warning(errorMessage);
              break;
            case ErrorShowType.ERROR_MESSAGE:
              console.log(errorMessage);
              break;
            case ErrorShowType.NOTIFICATION:
              notification.open({
                description: errorMessage,
                message: errorCode,
              });
              break;
            case ErrorShowType.REDIRECT:
              break;
            default:
              console.log(errorMessage);
          }
        }
      } else if (error.response) {
        console.log(error.response);
        if (error.response.status === 401) {
          message.error(getHttpErrorMessage(error));
          logoutToLogin({ preserveRedirect: true });
        } else {
          message.error(getHttpErrorMessage(error));
        }
        console.log(`Response status:${error.response.status}`);
      } else if (error.request) {
        message.error('网络异常，请检查网络后重试');
        console.log('None response! Please retry.');
      } else {
        message.error(error?.message || '请求失败，请稍后重试');
        console.log('error', error);
        console.log(error || '请求失败!');
      }
    },
  },
};
